import styled from 'styled-components';
import { ErrorMessege } from '../../style/themes.style';
export const LoginPageContainerContainer = styled.div`
  width: 100%;
  height: 60vh;
  align-content: center;
  justify-items: center;
`;

export const LoginPageContainer = styled.div`
  
  max-width: 600px;
  min-width: 30vw;
`;


export const ErrorP = ErrorMessege;